/* 
Copyright (c) Karsten Jeske and John Firth
This source code is licensed under the proprietary license found in the
LICENSE file in the root directory of this source tree.
*/

import Results from "features/results/Results"
import UserParametersForm from "features/userParameters/UserParametersForm"

const Home = () => {
  return (
    <>
      <div className="row py-1 p-3">
        <p>
          You&apos;re ready to retire, but how much can you withdraw from your portfolio without
          running out of money?
        </p>
        <p>
          This calculator lets you explore historically safe spending levels, based on the unique
          parameters of your retirement.
        </p>
      </div>
      <UserParametersForm />
      <Results />
    </>
  )
}

export default Home
